import { useMutation } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import { SUBMIT_TASK_ACTION } from '../consts/task';
import type { OutputData, SUBMIT_TASK_ACTION_TYPE } from '../types/task';
import customFetch from '../utils/fetch';
export const useSubmitTask = (taskId: number | undefined) => {
  const {
    mutate,
    data,
    isPending,
    isSuccess,
    isError,
    error
  } = useMutation({
    mutationKey: ['submitTask', taskId],
    mutationFn: async ({
      output,
      action,
      isRejected,
      pausedDueToInactivity
    }: {
      output: OutputData;
      action: SUBMIT_TASK_ACTION_TYPE;
      pausedDueToInactivity: boolean;
      isRejected?: boolean;
    }) => {
      const response = action === SUBMIT_TASK_ACTION.COMPLETE ? await customFetch(`${BASE_API_URL}/tasks/${taskId}/complete`, {
        method: 'POST',
        body: JSON.stringify({
          output,
          isRejected
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }) : await customFetch(`${BASE_API_URL}/tasks/${taskId}/update?autoPaused=${pausedDueToInactivity}`, {
        method: 'POST',
        body: JSON.stringify({
          output: {
            ...output
          },
          newStatus: 'PAUSED'
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const {
        success,
        error
      } = (await response.json() as {
        success: boolean;
        error: string;
        message: string;
      });
      if (!response.ok) {
        throw new Error(`Failed completing task: ${error}`);
      }
      if (!success) {
        throw new Error(`Failed completing task: ${error}`);
      }
      return {
        success
      };
    }
  });
  return {
    submitTask: mutate,
    actionStatus: data,
    isPending,
    isSuccess,
    isError,
    error
  };
};